import { render, staticRenderFns } from "./ForeignList.page.vue?vue&type=template&id=2a0aac1a&"
import script from "./ForeignList.page.vue?vue&type=script&lang=js&"
export * from "./ForeignList.page.vue?vue&type=script&lang=js&"
import style0 from "./ForeignList.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports